module.exports = "https://r.zoocdn.com/_next/static/images/safari-pinned-tab-e6af9054a60358e3ec71fd7bb004e14c.svg";